import React from 'react';

const About = () => {
    return (
        <>
            <p>
                I am an undergraduate studying Computer Science at Stanford
                University. Currently at the Stanford NLP Group focusing on
                parameter-efficient finetuning. I work with Aryaman Arora and Christopher Potts. 
            </p>
            <p>
                This summer, I'm working on quantized video generation and infrastructure at Roblox. I'll be joining Google Deepmind in the fall to work on adversarial robustness. 
            </p>
            <p>
                I'm interested in architecture, data efficiency, and inference. Outside of research, I cook, play soccer, and watch the Bulls. 
            </p>
       </>
    );
};

export default About;
